// extracted by mini-css-extract-plugin
module.exports = {"section":"RegionComments_section__1iGYI"};